import { createFileRoute } from '@tanstack/react-router';

import { filterState } from '@/_containers';
import { getInvoicesInfiniteQueryOptions } from '@/_pages/invoices/api-service';
import { InvoicesMainLoading } from '@/_pages/invoices/main/components';
import { invoicesMainListInfiniteLoaderParams } from '@/_pages/invoices/main-invoices/invoices-main-list-default-api-filter';

export const Route = createFileRoute('/_private/invoices/')({
  validateSearch: filterState.parse,
  staticData: { isFullWidth: true },
  loader: (opts) =>
    opts.context.queryClient.ensureInfiniteQueryData(
      getInvoicesInfiniteQueryOptions(invoicesMainListInfiniteLoaderParams)
    ),
  pendingComponent: InvoicesMainLoading,
});
